import { createApp, ref } from 'vue';
import App from './App.vue';
import router from './libs/routes.ts';
import userManager, { authenticatedUser } from './libs/usermanagement.ts';
import { createPinia } from 'pinia';
const pinia = createPinia();
const um = ref(userManager);
createApp(App)
    .use(pinia)
    .use(router)
    .provide('userManager', um)
    .provide('authenticatedUser', authenticatedUser)
    .mount('#app');
